<template>
  <div class="about">
    <section class="section" id="hotel-main" v-if="loaded">
      <div class="container">
        <div class="columns is-variable is-multiline">
          <div class="column is-two-fifths-desktop is-offset-0-desktop is-6-tablet is-offset-3-tablet is-12-mobile ">
            <figure class="image hotel-image">
              <picture>
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=400&height=225&gravity=smart&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(max-width: 480px)" />
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=281&gravity=smart&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(max-width: 768px)" />
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(max-width: 1023px)" />
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=350&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(max-width: 1215px)" />
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=440&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(max-width: 1407px)" />
                <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=520&quality=50&interlace=true&type=auto&file=${hotel.image}`" media="(min-width: 1408px)" />
                <img :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=720&quality=50&interlace=true&type=auto&file=${hotel.image}`" :alt="hotel.name" />
              </picture>

              <!-- <Badge v-if="this.$whitelabel.short.toLowerCase() === 'greenstorm'" :text="`Geld-zurück<br>Garantie`" :color="['rgba(133, 176, 19, 1)', 'rgba(133, 176, 19, 1)']" class="offer__badge  c-badge--greenstorm" /> -->
            </figure>
          </div>
          <div class="column is-half-desktop is-12-touch">
            <h1 class="title">
              {{ hotel.name }}
              <StarDisplay :stars="hotel.category" />
            </h1>
            <h2 class="subtitle mb-5 mb-6">
              {{ hotel.address }}, {{ hotel.zip }} {{ hotel.city }}, {{ hotel.state }},
              <router-link
                class="has-text-weight-normal"
                :to="{
                  name: 'search-by-country',
                  params: {iso: hotel.country, country: $t(`countries.${hotel.country}`)},
                }"
              >
                {{ $t(`countries.${hotel.country}`) }}
              </router-link>
            </h2>

            <h3 v-if="hotel.regions && hotel.regions.length > 0" class="title is-4 mb-2">{{ $t('general.region') }}</h3>

            <ul v-if="hotel.regions && hotel.regions.length > 0" class="mb-5">
              <li v-for="reg in hotel.regions" :key="reg.id">
                <router-link
                  :to="{
                    name: 'search',
                    query: {tags: reg.name},
                  }"
                >
                  {{ reg.name }}
                </router-link>
              </li>
            </ul>

            <p class="has-text-weight-semibold variant-header-text is-size-5 is-10">{{ $t('product.choose-offer') }}:</p>
            <div class="variants">
              <div class="variant-wrapper" v-for="product in offers" :key="product.id">
                <router-link :to="{name: 'urlaub', params: {slug: product.slug, contact: product.contact.slug}}" class="is-flex u-w100">
                  <div class="columns is-gapless is-size-6 variant box is-mobile is-marginless">
                    <div class="column is-11">
                      <div class="columns is-mobile is-multiline">
                        <div class="column is-5-widescreen is-12-desktop is-12-mobile is-size-7-mobile">
                          <strong class="is-inline-block">{{ product.display }}</strong>
                          <span class="is-inline-block"> <MinMaxDisplay :min="product.nights.min" :max="product.nights.max" />{{ $t('general.nights') }} </span>,
                          <span class="is-inline-block" v-for="board in product.boards" :key="board.short">{{ board.longName }}</span>
                        </div>
                        <div class="column is-7-widescreen is-12-desktop is-12-mobile" style="position:relative;">
                          <section class="is-small has-text-right">
                            <span v-if="$whitelabel.showReduction && product.persons.min != 2"> {{ $t('general.instead-of') }} {{ product.price.list | amount }} </span>
                            <span v-if="$whitelabel.showReduction && product.persons.min == 2"> {{ $t('general.instead-of') }} {{ (product.price.list / 2) | amount }} </span>
                            <div class="has-text-right">
                              <p class="has-text-weight-bold" v-bind:class="{'is-size-7 is-size-6-touch': $whitelabel.hasOfferCta, 'is-size-6 is-size-7-mobile': !$whitelabel.hasOfferCta}">
                                <span v-if="!$whitelabel.hasOfferCta">{{ product.price.prefix }}</span>
                                <span v-if="$whitelabel.hasOfferCta">{{ product.price.prefix | pricePrefixAbbr }}</span
                                >&nbsp;
                                <span class="is-size-3 is-size-4-mobile is-inline-block card-offer__price-wrapper">
                                  {{ product.price.currency | currency }}
                                  <span class="card-offer__price is-inline-block" ref="price">{{ product.price.display | amount }}</span>
                                </span>
                              </p>
                              <small v-if="$whitelabel.showTotalPrice" class="has-text-grey-light is-size-7-mobile"
                                >{{ product.persons.min }} {{ $t('general.persons') }} {{ product.price.currency | currency }} <span ref="priceTotal">{{ product.price.total | amount }}</span></small
                              >
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                    <div class="column variant-chevron is-1 ">
                      <b-icon class="has-text-primary" icon="chevron-right" size="is-large"> </b-icon>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section has-background-white is-medium hotel-content">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2 is-fullwidth-print" v-if="loaded">
            <HotelMainText v-if="$whitelabel.short == 'whitelabelapi'" :contactid="hotel.idSstOfferContact" />
            <HotelFeatures v-show="hotel.features.length > 0" v-if="hotel.features" :features="hotel.features" />
          </div>
        </div>
      </div>
    </section>
    <section class="section hotel-content" v-if="loaded">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2 is-fullwidth-print">
            <h3 class="title">{{ $t('general.map') }}</h3>
            <GoogleMaps v-if="hotel.geoCoordinate" :latitude="hotel.geoCoordinate.latitude" :longitude="hotel.geoCoordinate.longitude" :contact="hotel" />
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="section" v-if="offers && offers.length == 0">
      <div class="container">
        <div class="columns is-multiline is-variable is-5">
          <strong>Für dieses Hotel haben wir derzeit kein Angebot</strong>
        </div>
      </div>
    </section> -->
    <!-- <OfferBlock title="Angebote" :offers="offers" /> -->
  </div>
</template>

<script>
import hotelApi from '@/api/hotel-api'
import offerApi from '@/api/offer-api'
import store from '../_store'
import {mapGetters} from 'vuex'
import StarDisplay from '@/components/StarDisplay'
import MinMaxDisplay from '@/components/MinMaxDisplay'
// import Separator from '@/components/Separator'
import HotelFeatures from '../_components/HotelFeatures'
import HotelMainText from '../_components/HotelMainText'

//import Gtm from '@/common/google-tag-manager'
//const Badge = () => import(/* webpackChunkName: "badge" */ '@/components/Badge')
const GoogleMaps = () => import(/* webpackPrefetch: true , webpackChunkName: "googlemaps" */ '../_components/GoogleMaps')

// const OfferBlock = () => import(/* webpackPrefetch: true , webpackChunkName: "offerblock" */ '@/components/OfferBlock')
export default {
  name: 'HotelView',
  components: {
    //Badge,
    HotelFeatures,
    StarDisplay,
    MinMaxDisplay,
    GoogleMaps,
    HotelMainText,
    // Separator,
    // OfferBlock,
  },
  data() {
    return {
      loaded: false,
      hotel: {},
      offers: [],
      page: 1,
      pageSize: 16,
    }
  },
  computed: {
    ...mapGetters({
      isAnalyticsDeactivated: 'isAnalyticsDeactivated',
    }),
    snippedData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: window.location.origin,
        logo: this.$whitelabel.logoHeader,
      }
    },
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  async mounted() {
    const to = this.$route
    if (to.params.contact) {
      const data = await hotelApi.getHotel(to.params.contact)
      this.hotel = data
      if (this.hotel.slug) {
        try {
          const offers = await offerApi.getOfferForContact(this.hotel.slug, this.page, this.pageSize)
          this.offers = offers.results
        } catch {
          this.offers = []
        }
      }

      this.loaded = true
    }
  },
  methods: {},
  metaInfo() {
    const title = this.hotel.name
    return {
      title: title,
      meta: [
        {
          name: 'description',
          content: `Alle Angebote für ${this.hotel.name}`,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.offer__badge {
  position: absolute;
  left: 1.5rem;
  bottom: 1.5rem;
}

h4[name='hotelFeatures'] {
  font-size: 2rem !important;
}
</style>
